import { useNavigate } from 'react-router-dom';
import * as routing from '../constants/Routing';
import { useShowSnackbarMessage } from './useShowSnackbarMessage';

interface UseErrorMiddlewareResponseProps {
  execute: (error: any) => void;
}

// Hooks act as 'Adapter' layer.
export const useErrorMiddleware = (): UseErrorMiddlewareResponseProps => {
  const navigate = useNavigate();
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const execute = (error: any) => {
    console.info(`ErrorMiddleware:`, error);

    if (!error) return;

    if (error.code === `ERR_NETWORK`) {
      showSnackbarMessage({
        messageIntlId: `drivers.network_is_offline`,
      });
      return;
    }

    if (!error.response) return;

    if (error.response.status === 401) {
      navigate(routing.LOGOUT);
      return;
    }

    if (error.response.data?.messageId === `highway.subscription.error.expired_subscription`) {
      navigate(routing.SUBSCRIPTION_EXPIRED);
      showSnackbarMessage({
        messageIntlId: `infoerror.highway.subscription.error.expired_subscription`,
      });
      return;
    }

    showSnackbarMessage({
      messageIntlId: `infoerror.${error.response.data?.messageId ?? `network_error`}`,
    });
  };

  return {
    execute,
  };
};
